const graphics = {
    title: String("Gráficos"),
    graphicsManagerTitle: String("Gestión de gráficos"),
    batteryChartTitle: String("Tensión de Batería (V)"),
    temperatureChartTitle: String("Temperatura (ºC) y Humedad Relativa (%)"),
    leafHumidityChartTitle: String("Humedad en Hoja (mV)"),
    rainmeterChartTitle: String("Pluviometria (L)"),
    flowmeterChartTitle: String("Caudalimetro (L/m3)"),
    rainAndFlowChartTitle: String("Pluviometria (L) y Caudalimetro (L/m3)"),
    soilMoistureChartTitle: String("Sondas de Humedad en Suelo"),
    selectorPlaceholder: String("Lista estaciones"),
    generateChartsButton: String("Generar gràficos"),
    fetchingDataButton: String("Generando"),
    fetchingDataMessage: String("Los gráficos se estan generando. Espera un momento"),
    largeDataAdviseMessage: String("Para periodos largos este proceso puede tardar varios minutos"),
    noModulesAvailable: String("No hay ninguna estación disponible"),
    fetchingNotFoundMessage: String("No se han encontrado datos para esta estación en el rango de fechas seleccionado."),
    noDataSelected: String("No se ha seleccionado ningún dato"),
    accumulatedRainLabel: String("Lluvia acumulada"),
    accumulatedFlowLabel: String("Riego acumulado"),
    downloadDataset: String("Descargar datos"),
    // Dropdown
    generateReport: String("Generar informe"),
    temperatureDropdownItem: String("Temperatura y Humedad Relativa"),
    leafHumidityDropdownItem: String("Humedad en Hoja"),
    rainAndFlowDropdownItem: String("Pluviometria y Caudalimetro"),
    soilMoistureDropdownItem: String("Sondas de Humedad en Suelo"),
    dropdownAnalysisOption: String("Analisis del riego"),
    download: String("Descargar"),
    moduleName: String("Nombre Estación"),
    moduleId: String("Código Estación"),
    modulePeriod: String("Periodo"),

    //Modal
    generatingReport: String("Generando informe"),
    genTempHumChartMsg: String("Exportando gráfico de temperatura y humedad"),
    genLeafHumChartMsg: String("Exportando gráfico de humedad en hoja"),
    genSoilChartMsg: String("Exportando gráfico de humedad en suelo"),
    genRainFlowChartMsg: String("Exportando gráfico de pluviometria y caudalímetro"),
    genPDFMsg: String("Generando informe en PDF"),
    genDownloadingPDFMsg: String("Descargando informe"),

    legendWaterNotAvailable:    String('Agua no disponible'),
    legendWaterAvailable:       String('Agua disponible'),
    legendWaterEasyAvailable:   String('Agua fácilmente disponible'),
}

export default graphics;